<template>
  <div>
    yxvue
  </div>
</template>
<script>
  import axios from '@/axios'
  import tools from '@/tools'
  export default {
    computed: {
      chartWidth() {
        return (document.body.clientWidth - 200) / 3
      },
      chartHeight() {
        return (document.body.clientHeight - 200) / 2
      },
      canvasWidth() {
        return (document.body.clientWidth - 200)/ 2
      },
      canvasHeight() {
        return 50
      },

    },
    data() {
      return {
        list: [],
        scrollLeft: 0,
        isShow: true,
        cardBodyStyle: tools.style.card,
        options: [],

        tableDataMonth: [],
        // src: require('../../../assets/img/miniqr.jpg')
        selectDate: tools.date.getDate(),
        selectGroup: {},
        groups: [],
      }
    },
    mounted() {
      // this.getGroups()

    },
    methods: {
      getGroups() {
        var url = 'order/Web/queryGroup.do'
        var param = {}
        axios.get(url, param).then(response => {
          if (response.data.code == '0') {
            this.groups = response.data.data
            if (response.data.data.length != 0) {
              this.selectGroup = response.data.data[0]
              this.getList()
            }
          } else {
            this.$message({
              type: 'error',
              message: response.data.msg,
            });
          }
        });
      },
      changeGroup(value) {
        console.log(value)
        this.selectGroup = value
        this.getList()
      },
      changeDate(value) {
        this.selectDate = value
        this.getList()
      },
      getList() {
       this.isShow = false
        var url = 'order/Appoint/queryReport.do'
        var param = {
          useDate: this.selectDate,
          groupId: this.selectGroup.id
        }
        axios.get(url, param).then(res => {
          this.list = res.data.data
          setTimeout(() => {
            var fontSize = 24
            var topY = 10
            var lineY = this.canvasHeight - 20
            var perHourWidth = this.canvasWidth / 24
            var perMinWidth = perHourWidth / 60
            this.scrollLeft = perHourWidth * 8
            // console.log('canvasWidth:' + this.canvasWidth)
            // console.log('canvasHeight:' + this.canvasHeight)
            // console.log('perHourWidth:' + perHourWidth)
            // console.log('perMinWidth:' + perMinWidth)

            var myDate = new Date();
            var nowHour = myDate.getHours();
            var nowMin = myDate.getMinutes();


            for (var m = 0; m < this.list.length; m++) {
              var group = this.list[m]
              for (var n = 0; n < group.rooms.length; n++) {
                var room = group.rooms[n]
                var context = document.getElementById(room.roomName).getContext("2d")


                // console.log('moveTo(0, lineY):' + '0,' + lineY)
                // console.log('lineTo:' + this.canvasWidth + ',' + lineY)


                context.beginPath();
                context.moveTo(0, lineY)
                context.lineTo(this.canvasWidth, lineY)
                context.closePath();
                context.stroke();

                for (var item of room.appoints) {
                  context.fillStyle = '#0faeff'
                  context.fillRect(item.start * perMinWidth, topY, item
                    .duration *
                    perMinWidth,
                    lineY - topY)
                }


                for (var i = 0; i <= 24; i++) {
                  context.fillStyle = 'black'
                  context.fontSize = fontSize
                  context.beginPath();
                  // console.log('moveTo(0, lineY):' + (i * perHourWidth) +',' +( lineY- 5) )
                  // console.log('lineTo:' + i * perHourWidth + ',' + lineY)
                  context.moveTo(i * perHourWidth, lineY - 5)
                  context.lineTo(i * perHourWidth, lineY)
                  context.closePath();
                  context.stroke();

                  var offset
                  if (i == 0) {
                    offset = 0
                  } else if (i < 10) {
                    offset = fontSize / 8
                  } else if (i >= 10 && i <= 23) {
                    offset = fontSize / 4
                    //  offset = 0
                  } else {
                    // offset = fontSize + fontSize / 4
                    offset = fontSize / 2
                  }
                  context.fillText(i, i * perHourWidth - offset, lineY + 10)
                }

                context.strokeStyle = '#AAAAAA'
                context.stroke()

                context.beginPath()
                context.moveTo((nowHour * 60 + nowMin) * perMinWidth, 0)
                context.lineTo((nowHour * 60 + nowMin) * perMinWidth, lineY)
                context.strokeStyle = 'black'
                context.stroke()
                // context.draw()
              }
            }
          }, 200)

          this.$nextTick(() => {
            this.isShow = true
          })


        })
      },




      getWare() {
        var url = 'maint/MaintWare/queryByUserId.do'
        var param = {}
        axios.get(url, param).then(response => {
          var all = {
            name: '全部'
          }
          this.options = response.data.data
          this.options.splice(0, 0, all)
          console.log(JSON.stringify(this.options))
          this.query.ware = all
          // if (response.data.data.length > 0) {
          //   this.query.ware = response.data.data[0]
          // }
        });
      },
      change(val) {
        this.drawChart1()
        this.drawChart2()
        this.getTableDataMonth()
      },
      getTableDataMonth() {
        var url = 'ware/Report/month.do'
        var param = {
          wareName: this.query.ware.name
        }
        axios.get(url, param).then(response => {
          this.tableDataMonth = response.data.data
        })
      },

      drawChart1() {
        var myChart1 = this.$echarts.init(this.$refs.myChart1)
        var url = 'ware/Report/inout.do'
        var param = {
          wareName: this.query.ware.name
        }
        axios.get(url, param).then(response => {
          var option = {
            title: {
              text: '七日吞吐',
              subtext: '',
              left: 'center'
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['入库量', '出库量'],
              left: 'left',
            },
            toolbox: {
              show: true,
              feature: {
                dataView: {
                  show: true,
                  readOnly: false
                },
                magicType: {
                  show: true,
                  type: ['line', 'bar']
                },
                restore: {
                  show: true
                },
                saveAsImage: {
                  show: true
                }
              }
            },
            calculable: true,
            xAxis: [{
              type: 'category',
              data: response.data.data.xData
            }],
            yAxis: [{
              type: 'value'
            }],
            series: [{
                name: '入库量',
                type: 'bar',
                data: response.data.data.inData,
                markPoint: {
                  data: [{
                      type: 'max',
                      name: '最大值'
                    },
                    {
                      type: 'min',
                      name: '最小值'
                    }
                  ]
                },
                markLine: {
                  data: [{
                    type: 'average',
                    name: '平均值'
                  }]
                }
              },
              {
                name: '出库量',
                type: 'bar',
                data: response.data.data.outData,
                markPoint: {
                  data: [{
                      type: 'max',
                      name: '最大值'
                    },
                    {
                      type: 'min',
                      name: '最小值'
                    }
                  ]
                },
                markLine: {
                  data: [{
                    type: 'average',
                    name: '平均值'
                  }]
                }
              }
            ]
          };
          myChart1.setOption(option);
        });
      },
      drawChart2() {

        let myChart2 = this.$echarts.init(this.$refs.myChart2)
        var url = 'ware/Report/structure.do'
        var param = {
          wareName: this.query.ware.name
        }
        axios.get(url, param).then(response => {


          var option = {
            title: {
              text: '库存结构',
              subtext: '',
              left: 'center'
            },
            toolbox: {
              show: true,
              feature: {
                dataView: {
                  show: true,
                  readOnly: false
                },
                restore: {
                  show: true
                },
                saveAsImage: {
                  show: true
                }
              }
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: 'left',
            },
            series: [{
              name: '品名',
              type: 'pie',
              radius: '50%',
              data: response.data.data,
              label: {
                formatter: ' {b}\n{c}\n {per|{d}%}',
                rich: {
                  per: {
                    color: '#fff',
                    backgroundColor: '#4C5058',
                    padding: [3, 4],
                    borderRadius: 4
                  }
                }
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          };
          myChart2.setOption(option);
        });
      },
      drawChart3() {
        // 基于准备好的dom，初始化echarts实例
        let myChart3 = this.$echarts.init(this.$refs.myChart3)
        var option = {
          title: {
            text: '某站点用户访问来源',
            subtext: '纯属虚构',
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
          },
          series: [{
            name: '访问来源',
            type: 'pie',
            radius: '50%',
            data: [{
                value: 1048,
                name: '搜索引擎'
              },
              {
                value: 735,
                name: '直接访问'
              },
              {
                value: 580,
                name: '邮件营销'
              },
              {
                value: 484,
                name: '联盟广告'
              },
              {
                value: 300,
                name: '视频广告'
              }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        };

        myChart3.setOption(option);
      },


      drawChart4() {
        // var myChart1 = this.$echarts.init(document.getElementById('myChart1'))
        var myChart4 = this.$echarts.init(this.$refs.myChart4)
        var option = {
          title: {
            text: '漏斗图(对比)',
            subtext: '纯属虚构',
            left: 'left',
            top: 'bottom'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}%'
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            feature: {
              dataView: {
                readOnly: false
              },
              restore: {},
              saveAsImage: {}
            }
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: ['产品A', '产品B', '产品C', '产品D', '产品E']
          },

          series: [{
              name: '漏斗图',
              type: 'funnel',
              width: '40%',
              height: '45%',
              left: '5%',
              top: '50%',
              funnelAlign: 'right',

              center: ['25%', '25%'], // for pie

              data: [{
                  value: 60,
                  name: '产品C'
                },
                {
                  value: 30,
                  name: '产品D'
                },
                {
                  value: 10,
                  name: '产品E'
                },
                {
                  value: 80,
                  name: '产品B'
                },
                {
                  value: 100,
                  name: '产品A'
                }
              ]
            },
            {
              name: '金字塔',
              type: 'funnel',
              width: '40%',
              height: '45%',
              left: '5%',
              top: '5%',
              sort: 'ascending',
              funnelAlign: 'right',

              center: ['25%', '75%'], // for pie

              data: [{
                  value: 60,
                  name: '产品C'
                },
                {
                  value: 30,
                  name: '产品D'
                },
                {
                  value: 10,
                  name: '产品E'
                },
                {
                  value: 80,
                  name: '产品B'
                },
                {
                  value: 100,
                  name: '产品A'
                }
              ]
            },
            {
              name: '漏斗图',
              type: 'funnel',
              width: '40%',
              height: '45%',
              left: '55%',
              top: '5%',
              funnelAlign: 'left',

              center: ['75%', '25%'], // for pie

              data: [{
                  value: 60,
                  name: '产品C'
                },
                {
                  value: 30,
                  name: '产品D'
                },
                {
                  value: 10,
                  name: '产品E'
                },
                {
                  value: 80,
                  name: '产品B'
                },
                {
                  value: 100,
                  name: '产品A'
                }
              ]
            },
            {
              name: '金字塔',
              type: 'funnel',
              width: '40%',
              height: '45%',
              left: '55%',
              top: '50%',
              sort: 'ascending',
              funnelAlign: 'left',

              center: ['75%', '75%'], // for pie

              data: [{
                  value: 60,
                  name: '产品C'
                },
                {
                  value: 30,
                  name: '产品D'
                },
                {
                  value: 10,
                  name: '产品E'
                },
                {
                  value: 80,
                  name: '产品B'
                },
                {
                  value: 100,
                  name: '产品A'
                }
              ]
            }
          ]
        };

        myChart4.setOption(option);
      },

      drawChart5() {
        // var myChart1 = this.$echarts.init(document.getElementById('myChart1'))
        var myChart5 = this.$echarts.init(this.$refs.myChart5)
        var option = {
          series: [{
            type: 'gauge',
            anchor: {
              show: true,
              showAbove: true,
              size: 18,
              itemStyle: {
                color: '#FAC858'
              }
            },
            pointer: {
              icon: 'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
              width: 8,
              length: '80%',
              offsetCenter: [0, '8%']
            },

            progress: {
              show: true,
              overlap: true,
              roundCap: true
            },
            axisLine: {
              roundCap: true
            },
            data: [{
                value: 20,
                name: '完成率',
                title: {
                  offsetCenter: ['-40%', '80%']
                },
                detail: {
                  offsetCenter: ['-40%', '95%']
                }
              },
              {
                value: 40,
                name: '达标率',
                title: {
                  offsetCenter: ['0%', '80%']
                },
                detail: {
                  offsetCenter: ['0%', '95%']
                }
              },
              {
                value: 60,
                name: '优秀率',
                title: {
                  offsetCenter: ['40%', '80%']
                },
                detail: {
                  offsetCenter: ['40%', '95%']
                }
              }
            ],
            title: {
              fontSize: 14
            },
            detail: {
              width: 40,
              height: 14,
              fontSize: 14,
              color: '#fff',
              backgroundColor: 'auto',
              borderRadius: 3,
              formatter: '{value}%'
            }
          }]
        };


        myChart5.setOption(option);
        setInterval(function() {
          option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0;
          option.series[0].data[1].value = (Math.random() * 100).toFixed(2) - 0;
          option.series[0].data[2].value = (Math.random() * 100).toFixed(2) - 0;
          myChart5.setOption(option, true);
        }, 2000);
      },

      drawChart6() {
        // var myChart1 = this.$echarts.init(document.getElementById('myChart1'))
        var myChart6 = this.$echarts.init(this.$refs.myChart6)

        var hours = ['12a', '1a', '2a', '3a', '4a', '5a', '6a',
          '7a', '8a', '9a', '10a', '11a',
          '12p', '1p', '2p', '3p', '4p', '5p',
          '6p', '7p', '8p', '9p', '10p', '11p'
        ];
        var days = ['Saturday', 'Friday', 'Thursday',
          'Wednesday', 'Tuesday', 'Monday', 'Sunday'
        ];

        var data = [
          [0, 0, 5],
          [0, 1, 1],
          [0, 2, 0],
          [0, 3, 0],
          [0, 4, 0],
          [0, 5, 0],
          [0, 6, 0],
          [0, 7, 0],
          [0, 8, 0],
          [0, 9, 0],
          [0, 10, 0],
          [0, 11, 2],
          [0, 12, 4],
          [0, 13, 1],
          [0, 14, 1],
          [0, 15, 3],
          [0, 16, 4],
          [0, 17, 6],
          [0, 18, 4],
          [0, 19, 4],
          [0, 20, 3],
          [0, 21, 3],
          [0, 22, 2],
          [0, 23, 5],
          [1, 0, 7],
          [1, 1, 0],
          [1, 2, 0],
          [1, 3, 0],
          [1, 4, 0],
          [1, 5, 0],
          [1, 6, 0],
          [1, 7, 0],
          [1, 8, 0],
          [1, 9, 0],
          [1, 10, 5],
          [1, 11, 2],
          [1, 12, 2],
          [1, 13, 6],
          [1, 14, 9],
          [1, 15, 11],
          [1, 16, 6],
          [1, 17, 7],
          [1, 18, 8],
          [1, 19, 12],
          [1, 20, 5],
          [1, 21, 5],
          [1, 22, 7],
          [1, 23, 2],
          [2, 0, 1],
          [2, 1, 1],
          [2, 2, 0],
          [2, 3, 0],
          [2, 4, 0],
          [2, 5, 0],
          [2, 6, 0],
          [2, 7, 0],
          [2, 8, 0],
          [2, 9, 0],
          [2, 10, 3],
          [2, 11, 2],
          [2, 12, 1],
          [2, 13, 9],
          [2, 14, 8],
          [2, 15, 10],
          [2, 16, 6],
          [2, 17, 5],
          [2, 18, 5],
          [2, 19, 5],
          [2, 20, 7],
          [2, 21, 4],
          [2, 22, 2],
          [2, 23, 4],
          [3, 0, 7],
          [3, 1, 3],
          [3, 2, 0],
          [3, 3, 0],
          [3, 4, 0],
          [3, 5, 0],
          [3, 6, 0],
          [3, 7, 0],
          [3, 8, 1],
          [3, 9, 0],
          [3, 10, 5],
          [3, 11, 4],
          [3, 12, 7],
          [3, 13, 14],
          [3, 14, 13],
          [3, 15, 12],
          [3, 16, 9],
          [3, 17, 5],
          [3, 18, 5],
          [3, 19, 10],
          [3, 20, 6],
          [3, 21, 4],
          [3, 22, 4],
          [3, 23, 1],
          [4, 0, 1],
          [4, 1, 3],
          [4, 2, 0],
          [4, 3, 0],
          [4, 4, 0],
          [4, 5, 1],
          [4, 6, 0],
          [4, 7, 0],
          [4, 8, 0],
          [4, 9, 2],
          [4, 10, 4],
          [4, 11, 4],
          [4, 12, 2],
          [4, 13, 4],
          [4, 14, 4],
          [4, 15, 14],
          [4, 16, 12],
          [4, 17, 1],
          [4, 18, 8],
          [4, 19, 5],
          [4, 20, 3],
          [4, 21, 7],
          [4, 22, 3],
          [4, 23, 0],
          [5, 0, 2],
          [5, 1, 1],
          [5, 2, 0],
          [5, 3, 3],
          [5, 4, 0],
          [5, 5, 0],
          [5, 6, 0],
          [5, 7, 0],
          [5, 8, 2],
          [5, 9, 0],
          [5, 10, 4],
          [5, 11, 1],
          [5, 12, 5],
          [5, 13, 10],
          [5, 14, 5],
          [5, 15, 7],
          [5, 16, 11],
          [5, 17, 6],
          [5, 18, 0],
          [5, 19, 5],
          [5, 20, 3],
          [5, 21, 4],
          [5, 22, 2],
          [5, 23, 0],
          [6, 0, 1],
          [6, 1, 0],
          [6, 2, 0],
          [6, 3, 0],
          [6, 4, 0],
          [6, 5, 0],
          [6, 6, 0],
          [6, 7, 0],
          [6, 8, 0],
          [6, 9, 0],
          [6, 10, 1],
          [6, 11, 0],
          [6, 12, 2],
          [6, 13, 1],
          [6, 14, 3],
          [6, 15, 4],
          [6, 16, 0],
          [6, 17, 0],
          [6, 18, 0],
          [6, 19, 0],
          [6, 20, 1],
          [6, 21, 2],
          [6, 22, 2],
          [6, 23, 6]
        ];

        var option = {
          tooltip: {
            position: 'top'
          },
          title: [],
          singleAxis: [],
          series: []
        };

        days.forEach(function(day, idx) {
          option.title.push({
            textBaseline: 'middle',
            top: (idx + 0.5) * 100 / 7 + '%',
            text: day
          });
          option.singleAxis.push({
            left: 150,
            type: 'category',
            boundaryGap: false,
            data: hours,
            top: (idx * 100 / 7 + 5) + '%',
            height: (100 / 7 - 10) + '%',
            axisLabel: {
              interval: 2
            }
          });
          option.series.push({
            singleAxisIndex: idx,
            coordinateSystem: 'singleAxis',
            type: 'scatter',
            data: [],
            symbolSize: function(dataItem) {
              return dataItem[1] * 4;
            }
          });
        });

        data.forEach(function(dataItem) {
          option.series[dataItem[0]].data.push([dataItem[1], dataItem[2]]);
        });

        myChart6.setOption(option);
      },


    }
  }
</script>
<style>
  .cell-group-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 10rpx;
    font-size: 14px;
    color: rgb(143, 156, 162);
  }

  .cell-group-title-second {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 20rpx;
    font-size: 12px;
    color: rgb(143, 156, 162);
  }
</style>



// WEBPACK FOOTER //
// src/view/framework/cabin/yxvue.vue